import { render } from "./MonthlyBudget.vue?vue&type=template&id=0bea7cda"
import script from "./MonthlyBudget.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyBudget.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/MonthlyBudget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bea7cda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bea7cda', __exports__)) {
    api.reload('0bea7cda', __exports__)
  }
  
  module.hot.accept("./MonthlyBudget.vue?vue&type=template&id=0bea7cda", () => {
    api.rerender('0bea7cda', render)
  })

}


export default __exports__